import { render, staticRenderFns } from "./Multiselectbedding.vue?vue&type=template&id=72480c53&"
import script from "./Multiselectbedding.vue?vue&type=script&lang=js&"
export * from "./Multiselectbedding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports